import { outlookSafeLinkFixBeforeSend } from './beforeSend/outlookSafeLinkFixBeforeSend';
import { datadogLogs } from '@datadog/browser-logs';

export function initializeDatadogLogs({
  clientToken,
  env,
  service,
  version,
}: {
  clientToken: string;
  env: string;
  service: string;
  version: string;
}): void {
  datadogLogs.init({
    beforeSend: (event) => outlookSafeLinkFixBeforeSend(event),
    service,
    env,
    version,
    clientToken,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    trackSessionAcrossSubdomains: true,
    proxy: 'https://ddrp.apps.thrivent.com',
  });
}
